import { inject, Pipe, PipeTransform } from '@angular/core';
import { StringUtilsService } from '../services/string-utils.service';

@Pipe({
  name: 'FilterUser',
  standalone: false,
})
export class FilterUser implements PipeTransform {
  private readonly stringUtilsService = inject(StringUtilsService);
  transform(value: any, ...args: any) {
    let result = value;
    Object.keys(args).forEach((k, i, v) => {
      if (i == 0) {
        result = result.filter(
          (u) =>
            this.stringUtilsService
              .getNormalizedName(u.fullName)
              .toLowerCase()
              .trim()
              .indexOf(this.stringUtilsService.getNormalizedName(args[i])) >= 0
        );
      } else if (i == 1) {
        result = result.filter(
          (u) =>
            this.stringUtilsService
              .getNormalizedName(u.username)
              .toLowerCase()
              .trim()
              .indexOf(this.stringUtilsService.getNormalizedName(args[i])) >= 0
        );
      } else if (i == 2) {
        if (args[i] !== '' && args[i] !== undefined) {
          result = result.filter((u) => {
            return u.selectOdm === args[i];
          });
        }
      }
    });
    return result;
  }
}
